import {Component, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-bottom-bar',
  templateUrl: './bottom-bar.component.html',
  styleUrls: ['./bottom-bar.component.sass'],
})
export class BottomBarComponent implements OnInit {
  versionNumber = environment.version;

  constructor() {}

  ngOnInit(): void {}
}
